<template>
	<div class="form_main">
		<div class="nav_cont">
			<div class="fh" @click="go_router"><i class="el-icon-arrow-left" style="margin-right: 12px;"></i>返回</div>
			<div class="fabu">{{product_id > 0 ? '编辑商品' : '发布商品'}}</div>
		</div>
		<div class="formtit">基础信息</div>
		<div class="form_parameter">
			<el-row>
				<el-col :span="16">
					<el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
						<el-form-item label="商品图片" prop="pro_img">
							<div class="uploader-group">
								<el-upload class="upload-video" v-loading="videoFlag" action=""
									:disabled="videoPath != ''" :http-request="fnUploadRequest" :show-file-list="false"
									:before-upload="beforeUploadVideo">
									<template v-if="videoPath && !videoFlag">
										<div @click="previewVideo">
											<img :src="videoCoverPath" class="player-div" />
											<img src="../../assets/img/goods/play.png" class="play-icon" />
										</div>
									</template>
									<div v-else-if="!videoPath && !videoFlag" class="uploader-div">
										<img src="../../assets/img/goods/upload-video.png" class="i_upload-video" />
									</div>
									<i v-if="videoPath && !videoFlag" class="el-icon-error gp-product_del"
										@click.stop="clearVideoPath"></i>
								</el-upload>

								<el-upload class="upload-image" ref="upload_img" :file-list="fileList"
									:headers="upload.headers" :action="upload.url" list-type="picture-card"
									:on-success="getfile" :multiple="true" :limit="9" :on-preview="previewImage"
									:before-upload="beforeAvatarUpload" :on-progress="onthecross"
									:on-remove="handleRemove" :class="{disUoloadSty:noneBtnImg}">
									<div class="uploader-div">
										<i class="el-icon-plus"></i>
									</div>
								</el-upload>
							</div>

							<el-dialog width="540px" :visible.sync="showPreviewDialog"
								:before-close="closePreviewDialog">
								<template v-if="previewImageUrl">
									<img :src="previewImageUrl" style="width: 500px;height: 480px;object-fit: contain;"
										height="auto" />
								</template>
								<template v-else-if="previewVideoUrl">
									<video autoplay="autoplay" :src="previewVideoUrl"
										style="width: 500px;height: 480px;" controls="">您的浏览器不支持视频播放</video>
								</template>
							</el-dialog>
							<p class="img_js">最多上传9个商品图、1个视频，建议图片尺寸700*700、视频尺寸1:1，图片最大不超过{{imgMaxSize}}M</p>
						</el-form-item>

						<el-form-item label="商品名称" prop="name">
							<el-input style="padding: 0;" type="textarea" placeholder="填写商品名称与关键字" v-model="ruleForm.name" maxlength="60"
								show-word-limit class="pro_ goods_name" @input="changeInput($event,'title')">
							</el-input>
						</el-form-item>
						<el-form-item label="商品类目" prop="cate">
							<div class="pro-cate-view pro-cate-noallow" v-if="has_cate>0">
								<div class="pro-cate-val">{{cate_info.name}}</div>
							</div>
							<div class="pro-cate-view" @click="showCate" v-else>
								<div v-if="has_cate==0&&cate_id==0" class="pro-cate-place">选择所属行业类目</div>
								<div v-else-if="cate_id>0" class="pro-cate-val">{{cate_name}}</div>
								<i class="el-icon-arrow-down pro-cate-right"></i>
							</div>
						</el-form-item>
						<el-dialog  title="选择类目" width="1127px" :visible.sync="showCateDialog"
							:before-close="closeCateDialog">
							<div v-if="roots.length==0">
								<img class="no-cate-img" src="../../assets/img/order/nodeliver.png">
								<div class="no-cate-txt">当前没有可选择的类目，您可前往【商品类目】申请类目</div>
								<el-button @click="goapply" class="go-apply-cate" type="primary">前往</el-button>
							</div>
							<div v-else>
								<div class="cate-chose-div">
									<div class="cate-apply-list" style="margin-right: 12px;">
										<div v-for="(item,index) in roots" class="cate-apply-item" :class="{'cate-apply-item-act':index==root_index}" @click="changeRoot(index,1)">
											<div class="cate-apply-item-name">{{item.name}}</div>
											<img v-if="index==root_index" class="cate-apply-item-icon" src="../../assets/img/category/right-blue.png">
										</div>
									</div>
									<div v-if="paternal.length>0" class="cate-apply-list" style="margin-right: 12px;">
										<div v-for="(item,index) in paternal" class="cate-apply-item" :class="{'cate-apply-item-act':index==paternal_index}" @click="changeRoot(index,2)">
											<div class="cate-apply-item-name">{{item.name}}</div>
											<img v-if="index==paternal_index && item.leafFlag!=1" class="cate-apply-item-icon" src="../../assets/img/category/right-blue.png">
										</div>
									</div>
									<div v-if="parents.length>0" class="cate-apply-list" style="margin-right: 12px;">
										<div v-for="(item,index) in parents" class="cate-apply-item" :class="{'cate-apply-item-act':index==parent_index}" @click="changeRoot(index,3)">
											<div class="cate-apply-item-name">{{item.name}}</div>
											<img v-if="index==parent_index && item.leafFlag!=1" class="cate-apply-item-icon" src="../../assets/img/category/right-blue.png">
										</div>
									</div>
									<div v-if="cates.length>0" class="cate-apply-list" style="margin-right: 12px;">
										<div v-for="(item,index) in cates" class="cate-apply-item" :class="{'cate-apply-item-act':index==cate_index}" @click="changeRoot(index,4)">
											<div class="cate-apply-item-name">{{item.name}}</div>
											
										</div>
									</div>
								</div>
								<div class="cate-chose-bot">
									<el-button class="chose-cate-btn" @click="choseCate" type="primary">下一步</el-button>
								</div>
							</div>
						</el-dialog>
						
						<!-- 商品分组 -->
						<el-form-item id="classify" label="商品分组" prop="classify">
							<el-select v-model="classify" placeholder="请选择">
								<el-option v-for="s in classifys" :label="s.name" :value="s.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="商品单位" prop="unit">
							<el-input class="pro_" placeholder="例:件" v-model="ruleForm.unit" maxlength="3"
								 @input="changeInput($event,'unit')">
							</el-input>
						</el-form-item>
						<el-form-item label="商品运费" prop="freight" id="yf">
							<div>
								<el-radio v-model="postage_mode" label="0">包邮</el-radio>
								<el-radio v-model="postage_mode" label="1">固定金额</el-radio>
								<el-radio v-model="postage_mode" label="2">运费模板</el-radio>
							</div>
							
							<!-- 固定运费 -->
							<el-input v-if="postage_mode == 1" maxlength="7" placeholder="0.00" v-model="ruleForm.freight" style="width: 330px;" class="frei"
								onkeyup="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''">
								<template slot="prepend" >￥</template>
							</el-input>
							
							<!-- 运费模板 -->
							<template v-else-if="postage_mode == 2" >
								<el-select @visible-change="getTemplateChange" v-model="template_id" filterable placeholder="选择运费模板" style="width: 330px;">
									<el-option
									  v-for="item in freight_templates"
									  :key="item.id"
									  :label="item.name"
									  :value="item.id">
									</el-option>
								</el-select>
								<span class="add-postage-btn" @click="postageAdd">创建运费模板> </span>
							</template>
							
						</el-form-item>

						<el-form-item label="服务保障" prop="service_safe" id="service" v-if="guarantee_1.length > 0">
							<div v-for="(item, index) in guarantee_1" class="service_item"
								:class="{'service_action' : ruleForm.service_safe.indexOf(item.gid) !== -1}"
								@click="changeServices(item.gid)">{{item.name}}</div>
						</el-form-item>

						<el-form-item label="发货时间" prop="send_product_time">
							<el-select v-model="ruleForm.send_product_time" placeholder="请选择发货时间">
								<el-option v-for="item in guarantee_2" :key="item.gid" :label="item.label"
									:value="item.gid"></el-option>
							</el-select>
						</el-form-item>

						<div class="formtit">规格&库存</div>
						<div class="sku_info">
							<p
								style="font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #999999;">
								<span
									style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #333333;">批量设置</span>设置后将会对全部规格项进行批量填充
							</p>
							<el-row>
								<el-col :span="20"
									style="display: flex;align-items: center;justify-content:space-between;margin: 15px 0;font-size: 14px;">
									<div>
										库存<el-input maxlength="7" v-model.number="stock"
											@input="changeInput($event,'stock')"
											style="margin-left: 10px;width: 100px;"></el-input>
									</div>
									<div style="font-size: 14px;">
										商品售价
										<el-input placeholder="0.00" maxlength="7" v-model="price"
											@input="changeInput($event,'price')"
											style="width: 124px;margin-left: 10px;">
											<template slot="prepend">￥</template>
										</el-input>
									</div>
									<div style="font-size: 14px;">
										商品原价
										<el-input placeholder="0.00" maxlength="7" v-model="line_price"
											@input="changeInput($event,'line_price')"
											style="width: 124px;margin-left: 10px;">
											<template slot="prepend">￥</template>
										</el-input>
									</div>
									<el-button type="primary" @click="editSkuList()">设置</el-button>
								</el-col>
							</el-row>
							<div>
								<el-row>
									<el-col :span="20">
										<el-table :data="sku_list" border style="width: 100%;">
											<el-table-column prop="name" label="规格名称" align="center">
												<template slot='header'>
													<span class="bt">*</span>
													<span class="tableHeader">规格名称</span>
												</template>
												<template slot-scope="scope">
													<el-input maxlength="20" :value="scope.row.name"
														@input="changeInput($event,'list_name',scope.$index)"
														placeholder="请输入内容"></el-input>
												</template>
											</el-table-column>

											<el-table-column prop="stock" label="库存" align="center">
												<template slot='header'>
													<span class="bt">*</span>
													<span class="tableHeader">库存</span>
												</template>
												<template slot-scope="scope">
													<el-input maxlength="7" oninput="value=value.replace(/[^\d]/g,'')"
														:value="scope.row.stock"
														@input="changeInput($event,'list_stock',scope.$index)"
														placeholder="请输入内容"></el-input>
												</template>
											</el-table-column>

											<el-table-column prop="price" label="商品售价" align="center">
												<template slot='header'>
													<span class="bt">*</span>
													<span class="tableHeader">商品售价</span>
												</template>
												<template slot-scope="scope">
													<el-input maxlength="7" placeholder="0.00" :value="scope.row.price"
														@input="changeInput($event,'list_price',scope.$index)">
														<template slot="prepend">￥</template>
													</el-input>
												</template>
											</el-table-column>

											<el-table-column prop="line_price" label="商品原价" align="center">
												<template slot-scope="scope">
													<el-input maxlength="7" placeholder="0.00"
														:value="scope.row.line_price"
														@input="changeInput($event,'list_line_price',scope.$index)">
														<template slot="prepend">￥</template>
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="save" label="管理" align="center" width="100px">
												<template slot-scope="scope" v-if="sku_list.length > 1">
													<i class="el-icon-delete" style="font-size: 22px;cursor: pointer;"
														@click="deleteList('sku',scope.$index)"></i>
												</template>
											</el-table-column>
										</el-table>

									</el-col>
								</el-row>

								<div class="add_gz" @click="addSkuInfo" style="cursor: pointer;">+新增规格</div>
							</div>
						</div>

						<div class="formtit" style="margin-top: 30px;">商品描述</div>

						<el-row>
							<el-col :span="20">
								<div style="padding-left: 50px;">
									<quill-editor ref="text" v-model="content" :placeholder="placeholder"
										class="myQuillEditor" :options="editorOption" />
								</div>
							</el-col>
						</el-row>
						
						<div class="formtit" style="margin-top: 30px;">更多设置</div>
						<el-form-item label="商家编码" prop="own_code" id="owncode">
							<el-input v-model="ruleForm.own_code" maxlength="32"
							class="pro_"
								 @input="changeInput($event,'own_code')">
							</el-input>
						</el-form-item>

						<el-form-item style="margin-left: -120px;margin-top: 30px;margin-bottom: 30px;">
							<el-button v-if="status < 1" type="primary" @click="submitForm('ruleForm','1')" :disabled="!is_bind_submch">保存并上架
							</el-button>
							<el-button type="primary"
								style="width: 112px;height: 40px;background-color: #ffffff;border: 1px solid #DCDFE6;color: #606266;"
								@click="submitForm('ruleForm','-1')" :disabled="!is_bind_submch">{{product_id > 0 ? '保存' : '仅保存'}}</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<el-col :span="8">
					<div class="view_tips">实际效果参考</div>
					<div class="shijue">
						<img src="../../assets/img/public/xfzsj.jpg" style="width: 260px;" />
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import {
		getListByProduct
	} from '@/api/freight_template';
	import {
		getAgreeGuarantee
	} from '@/api/guarantee';
	import {
		editProduct,
		saveProduct,
		getGoodsCate,
		getProductClassify
	} from '@/api/goods';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor';
	import {
		handleCode
	} from '@/utils/request';
	import oss from '@/utils/oss';
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import {
		container,
		ImageExtend,
		QuillWatch
	} from 'quill-image-extend-module'
	Quill.register('modules/ImageExtend', ImageExtend)

	export default {
		name: 'publish',
		components: {
			quillEditor
		},
		data() {
			return {
				product_id: 0,
				is_bind_submch: 1,
				previewImageUrl: '',
				showPreviewDialog: false,
				showCateDialog:false,
				
				template_id: '',
				postage_mode: "0",
				freight_templates:[],
				
				fileList: [],
				uploadList: [], // 自定义的数组，用于处理fileList，fileList是只读的
				// ======= 视频上传
				videoId: 0,
				videoCover: 0,
				videoPath: '',
				videoCoverPath: '',
				videoFlag: false, //是否显示进度条
				previewVideoUrl: '',
				// =======
				// 照片墙
				imgMaxSize: 5, // 图片上传最大M
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] :
							''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
				status: 0,
				sku_list: [], //规格库存列表
				
				has_cate:0,
				cate_info:{},
				
				cate_id:0,
				parent_id:0,
				root_id:0,
				cate_name:'',
				
				cates:[],
				cate_index:-1,
				parents:[],
				parent_index:-1,
				paternal:[],
				paternal_index:-1,
				roots:[],
				root_index:-1,
				
				stock: 0, //库存
				price: '', //产品单价
				line_price: '', //产品原价
				sku_name: '',
				ruleForm: {
					name: '', //商品名
					rate: '',
					freight: '',
					service_safe: [],
					send_product_time: '',
					unit:'',
					own_code:''
				},
				content: '', //富文本
				detail_id: '', //编辑需要
				editorOption: {
					placeholder: '此处输入商品描述...',
					modules: {
						ImageExtend: {
							loading: true,
							name: 'file', //图片参数名
							size: 5, // 可选参数 图片大小，单位为M，1M = 1024kb
							action: baseURL + '/api/brand.Upload/oneToOss', //上传的服务器地址，如果action为空，则采用base64插入图片
							accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg',
							// response 为一个函数，用来获取服务器返回的具体图片地址
							response: res => {
								const imgUrl = res.data.url;
								return imgUrl
							},
							headers: xhr => {
								// 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
								xhr.setRequestHeader("authorization", this.$store.getters['user/accessToken'] ? this
									.$store.getters['user/accessToken'] : '')
							},
							// 可选参数 设置请求头部
							sizeError: (val) => {
								this.$message.error('请上传5M以内的图片');

							}, // 图片超过大小的回调
							start: () => {}, // 可选参数 自定义开始上传触发事件
							end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
							error: () => {}, // 可选参数 上传失败触发的事件
							success: () => {
								var qr = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("img");
								for (var i = 0; i < qr.length; i++) {
									qr[i].style.display = 'block';
									qr[i].style.width = '100%';
								}
							}, // 可选参数  上传成功触发的事件
							change: (xhr, formData) => {
								// xhr.setRequestHeader('myHeader','myValue')
								// formData.append('token', 'myToken')
							} // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
						},
						// 如果不上传图片到服务器，此处不必配置
						toolbar: {
							// container为工具栏，此次引入了全部工具栏，也可自行配置
							container: [
								["bold", "italic", "underline", "strike"],
								["blockquote", "code-block"],
								[{
									header: 1
								}, {
									header: 2
								}],
								[{
									list: "ordered"
								}, {
									list: "bullet"
								}],
								[{
									script: "sub"
								}, {
									script: "super"
								}],
								[{
									indent: "-1"
								}, {
									indent: "+1"
								}],
								[{
									direction: "rtl"
								}],
								[{
									size: ["small", false, "large", "huge"]
								}],
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									color: []
								}, {
									background: []
								}],
								[{
									font: []
								}],
								[{
									align: []
								}],
								["image"]
							],
							// 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
							handlers: {
								image: function() {
									// 劫持原来的图片点击按钮事件
									QuillWatch.emit(this.quill.id)
								}
							}
						}
					},
				},
				perspective: 1,
				is_submit: 0,
				placeholder: '请输入内容',
				showBtnImg: true,
				noneBtnImg: false,
				list_page: 0,
				activeName: 'all',
				max_rate: 22,
				guarantee_1: [],
				guarantee_2: [],
				
				classify: 0,
				classifys: [] // 产品分组
			}
		},
		created() {
			let head = document.getElementsByTagName('head');
			let meta = document.createElement('meta');
			meta.name = 'referrer';
			//根据实际情况修改referrer的值，可选值参考上文
			meta.content = 'no-referrer';
			head[0].appendChild(meta);
		},
		destroyed() {
			window.removeEventListener('popstate', this.goBack, false);
		},
		updated() {
			var qr = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("img");
			for (var i = 0; i < qr.length; i++) {
				qr[i].style.display = 'block';
			}
		},
		mounted() {
			var that = this;
			that.$refs.text.quill.enable(false);
			document.getElementsByClassName("father-main")[0].scrollTop = 0;
			setTimeout(() => {
				that.$refs.text.quill.enable(true);
				that.$refs.text.quill.blur();
			}, 500)
			let query = this.$route.query;
			var that = this;
			if (query.product_id > 0) {
				that.product_id = query.product_id;
			}
			if (query.list_page) {
				that.list_page = query.list_page;
			}
			if (query.list_page) {
				that.activeName = query.activeName;
			}
			this.init();
			this.getAgreeGuarantee();
			if (this.product_id == 0) {
				this.addSkuInfo();
			}
			//监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.goBack, false);
			}
		},
		methods: {
			goapply(){
				this.showCateDialog = false;
				this.$router.push({
					path: '/product/category-apply',
					query: {}
				});
			},
			changeRoot(index,type){
				if(type==1){
					if(index==this.root_index){
						return false;
					}
					this.root_index = index;
					this.paternal = [];
					this.paternal_index = -1;
					this.parents = [];
					this.parent_index = -1;
					this.cates = [];
					this.cate_index = -1;
					var cate_id = this.roots[index].id;
					this.getcate(cate_id,2);
				}
				if(type==2){
					if(index==this.paternal_index){
						return false;
					}
					this.paternal_index = index;
					this.parents = [];
					this.parent_index = -1;
					this.cates = [];
					this.cate_index = -1;
					var cate_id = this.paternal[index].id;
					this.getcate(cate_id,3);
				}
				if(type==3){
					if(index==this.parent_index){
						return false;
					}
					this.parent_index = index;
					this.cates = [];
					this.cate_index = -1;
					var cate_id = this.parents[index].id;
					this.getcate(cate_id,4);
				}
				if(type==4){
					if(index==this.cate_index){
						return false;
					}
					this.cate_index = index;
					
				}
				
			},
			choseCate(){
				if(this.root_index>=0&&this.paternal_index>=0 && this.parent_index>=0 && this.cate_index>=0){
					this.cate_id = this.cates[this.cate_index].id;
					this.cate_name = this.cates[this.cate_index].name;
					this.parent_id = this.parents[this.parent_index].id;
					this.paternal_id = this.paternal[this.paternal_index].id;
					this.root_id = this.roots[this.root_index].id;
					this.showCateDialog = false;
				}else if(this.root_index>=0&&this.paternal_index>=0 && this.parent_index>=0&&this.cates.length==0){
					this.cate_id = this.parents[this.parent_index].id;
					this.cate_name = this.parents[this.parent_index].name;
					this.parent_id = this.paternal[this.paternal_index].id;
					this.paternal_id = this.roots[this.root_index].id;
					this.root_id = this.roots[this.root_index].id;
					this.showCateDialog = false;
				}else if(this.root_index>=0&&this.paternal_index>=0 &&this.parents.length==0){
					this.cate_id = this.paternal[this.paternal_index].id;
					this.cate_name = this.paternal[this.paternal_index].name;
					this.parent_id = this.roots[this.root_index].id;
					this.paternal_id = this.roots[this.root_index].id;
					this.root_id = this.roots[this.root_index].id;
					this.showCateDialog = false;
				}else{
					this.$message.error('请先选择类目!');
					return false;
				}
			},
			getcate(cate_id='',level=1){
				getGoodsCate({
					cate_id: cate_id,
					level:level
				}).then(res => {
					if(res.code==0){
						if(level==1){
							this.roots = res.data;
						}else if(level==2){
							this.paternal = res.data;
						}else if(level==3){
							this.parents = res.data;
						}else{
							this.cates = res.data;
						}
					}
					
				})
			},
			showCate(){
				if(this.has_cate>0){
					return false;
				}
				if(this.roots.length==0){
					this.getcate();
				}
				this.showCateDialog = true;
			},
			/**
			 * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
			 * @params {object} option [上传选项]
			 * @return {null} [没有返回]
			 */
			async fnUploadRequest(option) {
				// var videoDOM = document.getElementById("hidden_video");
				// if (videoDOM.duration > 60) {
				// 	this.$message.error("视频时长请限制在1分钟内");
				// 	this.videoFlag = false;
				// 	return false;
				// }

				oss.ossUploadFile(option).then((res) => {
					if (res.errcode === 0) {
						this.videoFlag = false;
						if (res.data.code == 0) {
							this.videoId = res.data.data.video_id ? res.data.data.video_id : 0;
							this.videoCover = res.data.data.video_cover ? res.data.data.video_cover : 0;
							this.videoPath = res.data.data.video_url ? res.data.data.video_url : 0;
							this.videoCoverPath = res.data.data.video_cover_url ? res.data.data
								.video_cover_url : 0;
						} else {
							this.$message.error("上传失败");
						}
					} else {
						this.$message.error(res.errmsg);
					}
				});
			},
			//视频上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 50;
				if (['video/mp4', 'video/3gp', 'video/m3u8'].indexOf(file.type) === -1) {
					this.$message.error("视频格式仅支持：mp4，3gp，m3u8");
					return false;
				}
				if (!fileSize) {
					this.$message.error("视频大小不能超过50MB");
					return false;
				}

				this.videoFlag = true;
			},
			//清除视频
			clearVideoPath() {
				this.videoId = 0;
				this.videoCover = 0;
				this.videoPath = '';
				this.videoFlag = false;
			},
			init() {
				this.fileList = [];
				editProduct({
					id: this.product_id
				}).then(res => {
					if (res.code == 0) {
						var data = res.data;
						this.is_bind_submch = data.is_bind_submch;
						if (this.product_id == 0) {
							this.ruleForm.send_product_time = data.default_ship_time;
						} else {
							this.status = data.info.status;
							this.ruleForm.name = data.info.title;
							this.ruleForm.freight = data.info.postage;
							this.ruleForm.unit = data.info.unit;
							this.ruleForm.own_code = data.info.own_code;
							this.template_id = data.info.template_id > 0 ? data.info.template_id : '';;
							this.postage_mode = data.info.postage_mode + '';
							if (data.sku) {
								this.sku_list = data.sku;
							}
							if (data.media) {
								if (data.media.imgs) {
									let imgs = data.media.imgs;
									this.fileList = imgs;
									this.uploadList = imgs;
									this.noneBtnImg = imgs.length >= 9;
								}
								if (data.media.videos.length > 0) {
									let videos = data.media.videos;
									this.videoId = videos[0].video_id;
									this.videoPath = videos[0].video_url;
									this.videoCover = videos[0].video_cover_id;
									this.videoCoverPath = videos[0].video_cover_url;
								}
							}
							if (data.detail) {
								this.content = data.detail;
							}
							this.ruleForm.service_safe = data.guarantee.service;
							this.ruleForm.send_product_time = data.send_product_time ? data.send_product_time :
								data.default_ship_time;
						}
						if(data.has_cate){
							this.has_cate = data.has_cate;
							this.cate_info = data.cate_info;
						}else{
							this.getcate();
						}
						this.classifys = data.classify
						this.classify = data.checkClassify.id
					} else {
						this.$message.error(res.message);
						this.$router.back(-1);
					}
				})
				this.getFrightTemplate();
			},
			// 获取产品可用的运费模板
			getFrightTemplate(){
				getListByProduct({}).then(res => {
					if(res.code == 0){
						this.freight_templates = res.data;
					}
				});
			},
			getAgreeGuarantee() {
				getAgreeGuarantee({}).then(res => {
					if (res.code == 0) {
						this.guarantee_1 = res.data.guarantee_1;
						this.guarantee_2 = res.data.guarantee_2;
					}
				})
			},
			//删除图片
			handleRemove(file, fileList) {
				let index = this.fileList.findIndex(item => {
					return file.url === item.url
				})
				this.uploadList.splice(index, 1)
				this.fileList = fileList;
				this.noneBtnImg = this.fileList.length >= 9;
			},
			//上传完成
			getfile(response, file, fileList) {
				if (response.code == noPermissionCode) {
					handleCode(response.code, response.message);
				} else {
					this.fileList = fileList;
					var data = {
						file_id: response.data.id,
						url: response.data.url
					};
					this.uploadList.push(data)
				}
				this.noneBtnImg = this.fileList.length >= 9;
				this.$refs.upload_img.clearFiles(); //上传成功之后清除历史记录
			},
			//图片上传前验证
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < this.imgMaxSize;

				//观察图片几张了
				if (this.fileList.length + 1 > 9) {
					this.$message.error('最多可上传9张图');
					return false;
				}

				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}

				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 '+this.imgMaxSize+'MB!');
				}
				return isLt2M;
			},
			closePreviewDialog(done) {
				done();
				this.previewVideoUrl = '';
				this.previewImageUrl = '';
			},
			closeCateDialog(done){
				done();
			},
			// 预览视频
			previewVideo() {
				if (this.videoPath) {
					this.previewVideoUrl = this.videoPath;
					this.showPreviewDialog = true;
				}
			},
			// 预览图片
			previewImage(file) {
				this.previewImageUrl = file.url;
				this.showPreviewDialog = true;
			},
			onthecross() {
				var circle = document.getElementsByClassName("el-progress-circle");

				if (circle[0]) {
					circle[0].style.width = "80px";
					circle[0].style.height = "80px";
				}
			},
			//提交表单
			submitForm(formName, status) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.is_submit == 1) {
							return false;
						}
						this.is_submit = 1;
						// 必填项验证
						if (!this.uploadList || this.uploadList.length < 1) {
							this.$message.error("请上传商品图片");
							this.is_submit = 0;
							return false;
						}

						if (!this.ruleForm.name || this.ruleForm.name.length < 1) {
							this.$message.error("请输入商品名称");
							this.is_submit = 0;
							return false;
						}
						if(this.cate_id==0&&this.has_cate==0){
							this.$message.error("请选择商品类目");
							this.is_submit = 0;
							return false;
						}
						if (!this.ruleForm.unit || this.ruleForm.unit.length < 1) {
							this.$message.error("请输入商品单位");
							this.is_submit = 0;
							return false;
						}
						
						let postage_mode = this.postage_mode
						let freight = 0; 
						let template_id = 0;
						if(postage_mode == 1){
							freight = this.ruleForm.freight + '';
							if (freight <= 0) {
								this.$message.error("请正确输入运费");
								this.is_submit = 0;
								return false;
							} else {
								if (freight.indexOf(".") != -1 && freight.split('.')[1].length > 2) {
									this.$message.error("请正确输入运费");
									this.is_submit = 0;
									return false;
								}
							}
						}else if(postage_mode == 2){
							template_id = this.template_id
							if(template_id == undefined || template_id <= 0){
								this.$message.error("请选择运费模板");
								this.is_submit = 0;
								return false;
							}
						}
						

						if (this.ruleForm.send_product_time == '') {
							this.$message.error("请选择发货时间");
							this.is_submit = 0;
							return false;
						}

						let regNeg = /^\d{1,8}(\.\d{0,2})?$/; //负浮点数
						let sku_list = this.sku_list;
						for (let i in sku_list) {
							if (sku_list[i] && (sku_list[i]["name"] == "")) {
								this.$message.error("规格名称不能为空");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && String(sku_list[i]["price"]) == "") {
								this.$message.error("规格价格不能为空");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && sku_list[i]["stock"].length < 1) {
								this.$message.error("规格库存不能为空");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && !regNeg.test(sku_list[i]["price"])) {
								this.$message.error("商品单价不正确");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && Number(sku_list[i]["price"]) <= 0) {
								this.$message.error("商品单价不能小于等于0");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && Number(sku_list[i]["line_price"]) < 0) {
								this.$message.error("商品原价不能小于0");
								this.is_submit = 0;
								return false;
							} else if (sku_list[i] && (Number(sku_list[i]["stock"]) <= 0)) {
								if (this.product_id == 0) {
									this.$message.error("商品库存不能为0");
									this.is_submit = 0;
									return false;
								}
							}
						}
						var content = this.content;
						if (content) {
							content = format_rich_text__img(content);
						} else {
							content = '';
						}
						// console.log(this.fileList);
						// console.log(this.uploadList);
						// this.is_submit = 0;
						// return false;
						//图片排序
						var new_uploadList = [];
						new_uploadList = this.uploadList;
						var file_img_list = this.fileList;

						// for (var i = 0; i < file_img_list.length; i++) {
						// 	if (file_img_list[i]['response']) {
						// 		var z_url = file_img_list[i]['response']['data']['url'];
						// 	} else {
						// 		var z_url = file_img_list[i]['url'];
						// 	}
						// 	for (var b = 0; b < this.uploadList.length; b++) {
						// 		if (z_url == this.uploadList[b].url) {
						// 			new_uploadList.push(this.uploadList[b]);
						// 		}
						// 	}
						// }
						
						var cate_id,cate_name,parent_id,paternal_id,root_id;
						if(this.has_cate>0){
							cate_id = this.cate_info.id;
							cate_name = this.cate_info.name;
							parent_id = this.cate_info.parent_id;
							paternal_id = this.cate_info.paternal_id;
							root_id = this.cate_info.root_id;
						}else{
							cate_id = this.cate_id;
							cate_name = this.cate_name;
							parent_id = this.parent_id;
							paternal_id = this.paternal_id;
							root_id = this.root_id;
						}
						var classify = this.classify;
						saveProduct({
							category_id:cate_id,
							classify: classify,
							category_name:cate_name,
							parent_id:parent_id,
							paternal_id:paternal_id,
							root_id:root_id,
							unit:this.ruleForm.unit,
							own_code:this.ruleForm.own_code?this.ruleForm.own_code:'',
							status: status,
							id: this.product_id,
							title: this.ruleForm.name,
							postage: freight,
							headimg_list: JSON.stringify(new_uploadList),
							sku_info: JSON.stringify(this.sku_list),
							detail: trim(content),
							detail_id: this.detail_id,
							video_id: this.videoId,
							video_cover: this.videoCover,
							send_product_time: this.ruleForm.send_product_time,
							service_safe: JSON.stringify(this.ruleForm.service_safe),
							template_id: template_id
						}).then(res => {
							if (res.code == 0) {
								this.$message.success(res.message);
								this.$router.go(-1);
							} else {
								this.is_submit = 0;
								this.$message.error(res.message);
							}
						})
					} else {
						return false;
					}
				});
			},
			//添加规格列表
			addSkuInfo: function() {
				let sku_name = this.sku_name;
				var sku_info = {};
				sku_info["id"] = 0;
				sku_info["name"] = sku_name ? sku_name : '';
				sku_info["stock"] = '0';
				sku_info["price"] = 0;
				sku_info["line_price"] = 0;
				this.sku_name = "";
				this.sku_list.push(sku_info);
				console.log(this.sku_list)
			},
			//编辑规格列表,批量设置
			editSkuList: function() {
				let stock = this.stock;
				let price = this.price;
				let line_price = this.line_price;
				let sku_list = this.sku_list;
				for (let i = 0; i < sku_list.length; i++) {
					if (stock !== "" && stock !== 0) {
						sku_list[i]["stock"] = stock;
					}
					if (price !== "") {
						sku_list[i]["price"] = price;
					}
					if (line_price !== "") {
						sku_list[i]["line_price"] = line_price;
					}
				}
				this.sku_list = sku_list;
			},
			//修改input值
			changeInput: function(event, type = 'title', index = 0) {
				var oldvalue = '' + event;
				let that = this;
				var value = oldvalue.replace(/\s/g, "");
				switch (type) {
					case "sku_code":
						that.sku_list[index]['sku_code'] = oldvalue;
						break;
					case 'title':
						that.ruleForm.name = value;
						break;
					case 'share_title':
						that.share_title = value;
						break;
					case 'share_desc':
						that.share_desc = value;
						break;
					case 'buy_limit':
						value = value.replace(/[^\d]/g, "");
						that.buy_limit = Number(value);
						break;
					case 'postage':
						value = num(value);
						that.postage = parseFloat(value);
						break;
					case 'location':
						that.location = value;
						break;
					case 'address':
						that.address = value;
						break;
					case 'sku_name':
						that.sku_name = value;
						break;
					case 'unit':
						that.ruleForm.unit = value;
						break;
					case 'own_code':
						that.ruleForm.own_code = value;
						break;
					case 'stock':
						if (value != "") {
							value = value.replace(/[^\d]/g, "");
							value = Number(value);
						}
						that.stock = value;
						break;
					case 'price':
						value = num(value);
						that.price = value;
						break;
					case 'score':
						value = value.replace(/[^\d]/g, "");
						that.score = Number(value);
						break;
					case 'line_price':
						value = num(value);
						that.line_price = value;
						break;
					case 'vip_score':
						value = value.replace(/[^\d]/g, "");
						that.vip_score = Number(value);
						break;
					case 'list_name':
						that.sku_list[index]['name'] = value;
						break;
					case 'list_stock':
						if (value != "") {
							value = value.replace(/[^\d]/g, "");
							value = Number(value);
						}
						that.sku_list[index]['stock'] = value;
						break;
					case 'list_price':
						value = num(value);
						that.sku_list[index]['price'] = value;
						break;
					case 'list_score':
						value = value.replace(/[^\d]/g, "");
						that.sku_list[index]['score'] = Number(value);
						break;
					case 'list_line_price':
						value = num(value);
						that.sku_list[index]['line_price'] = value;
						break;
					case 'list_vip_score':
						value = value.replace(/[^\d]/g, "");
						that.sku_list[index]['vip_score'] = Number(value);
						break;
					case 'text_val':
						that.detail[index]['text_val'] = oldvalue;
						break;
					case 'classify_name':
						that.classify_name = value;
						break;
				}
			},
			deleteList: function(type = 'Img', index = 0, key = 0) {
				let that = this;
				switch (type) {
					case 'Img':
						that.img_list.splice(index, 1);
						$("#uploadProductImg").val('');
						break;
					case 'sku':
						that.sku_list.splice(index, 1);
						break;
					case 'detail_imgs_list':
						that.detail[index].imgs_list.splice(key, 1);
						break;
					case 'detail_lsit':
						that.detail.splice(index, 1);
						break;
				}
			},
			changeServices(gid) {
				var index = this.ruleForm.service_safe.indexOf(gid);
				if (index >= 0) {
					this.ruleForm.service_safe.splice(index, 1);
				} else {
					this.ruleForm.service_safe.push(gid);
				}
			},
			go_router() {
				this.$router.go(-1)
			},
			goBack() {
				// console.log("点击了浏览器的返回按钮");
				this.$router.go(-1)
			},
			// 添加运费模板
			postageAdd(){
				let pointSrc= this.$router.resolve({
					path: '/order/postage-add',
				});
				          
				// 打开一个新的页面     
				window.open(pointSrc.href, '_blank')
			},
			// 运费模板下拉框列表每次展开加载
			getTemplateChange(e){
				if(e){
					this.getFrightTemplate();
				}
			}
		}
	}
	/**
	 * [只能输入数字和两位小数]
	 * 举例：<input type="text" onkeyup="num(this)" size="10"/>
	 * @param obj
	 * @returns
	 * @data 20019-01-08
	 */
	function num(value) {
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字
		value = value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
		var smPric = /^\d{1,8}(\.\d{0,2})?$/;
		if (!smPric.test(value)) {
			return '';
		}
		return value;
	}

	/**
	 * 格式化富文本内容 -> 图片
	 * @params rich_text 富文本原始内容
	 * @return rich_text 格式化后的内容
	 * @author BJ
	 */
	function format_rich_text__img(rich_text) {
		let reg = /<img.+?>/gim;
		let tem = [];
		while (tem = reg.exec(rich_text)) {
			let img_text = tem[0];
			// 设置 width=100%
			if (img_text.indexOf('width="100%"') === -1) {
				let new_img_text = img_text.substr(0, img_text.length - 1) + ' width="100%">';
				rich_text = rich_text.replace(img_text, new_img_text);
				img_text = new_img_text;
			}
			// 设置 display: block
			if (img_text.indexOf('style="') === -1) {
				let new_img_text = img_text.substr(0, img_text.length - 1) + ' style="display: block;">';
				rich_text = rich_text.replace(img_text, new_img_text);
				img_text = new_img_text;
			}
		}
		return rich_text;
	}

	/**
	 * 格式化富文本内容 -> 去除首尾换行
	 * @params rich_text 富文本原始内容
	 * @return rich_text 格式化后的内容
	 * @author BJ
	 */
	function trim(rich_text) {
		let reg = /<p><br><\/p>/gim;
		let t = [];
		let arr = [];
		while (t = reg.exec(rich_text)) {
			arr.push(t.index)
		}
		let m = 11;
		let start = 0;
		let end = rich_text.length;
		for (var n = 0; n < arr.length; n++) {
			if (arr[n] != n * m) break;
			start = (n + 1) * m;
		}
		for (var n = arr.length; n > 0; n--) {
			if (arr[n - 1] != rich_text.length - ((arr.length - (n - 1)) * m)) break;
			end = arr[n - 1];
		}
		return rich_text.slice(start, end);
	}
</script>

<style>
	.father-main {
		overflow: auto;
	}

	.form_main {
		background: #ffffff;
	}

	@keyframes bganimation {
		0% {
			background-position: 0% 50%;
		}

		50% {
			background-position: 100% 50%;
		}

		0% {
			background-position: 0% 50%;
		}
	}

	.form_main .nav_cont {
		width: 100%;
		height: 60px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
		margin-bottom: 15px;
	}

	.formtit {
		width: 100px;
		height: 25px;
		border-left: 3px solid #409EFF;
		line-height: 25px;
		padding-left: 15px;
		margin-bottom: 23px;
	}

	.fh {
		width: 92px;
		height: 23px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
		border-right: 1px solid #CCCCCC;
		margin-right: 21px;
		cursor: pointer;
	}

	.fabu {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.form_parameter .el-upload--picture-card {
		width: 90px;
		height: 90px;
		line-height: 90px;
		border: 0;
	}

	.form_parameter .el-form-item__content {
		padding-left: 50px;
	}

	.img_js {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}

	.pro_ {
		width: 330px;
	}

	.sku_info {
		padding-left: 50px;
	}

	.add_gz {
		width: 105px;
		height: 40px;
		background: #E6F1FC;
		border-radius: 4px;
		border: 1px solid #A3D0FD;
		color: #409EFF;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		margin-top: 10px;
	}

	.form_parameter .el-upload-list--picture-card .el-upload-list__item {
		width: 90px;
		height: 90px;
		object-fit: cover;
	}

	.form_parameter .el-upload-list__item-thumbnail {
		object-fit: cover;
	}

	.ql-editor {
		min-height: 200px;
	}

	.shijue {
		width: 277px;
		height: 462px;
		background-color: #CCCCCC;
		overflow: auto
	}

	.p_shijue {
		width: 110px;
		height: 40px;
		border-radius: 4px;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		cursor: pointer;
	}

	.uploader-group {
		display: flex;
	}

	.upload-video {
		width: 90px;
		height: 90px;
	}

	.upload-video,
	.upload-image {
		position: relative;
		margin-right: 15px;
	}

	.player-div {
		width: 90px;
		height: 90px;
		object-fit: cover;
		border-radius: 4px;
	}

	.play-icon {
		width: 35px;
		height: 32px;
		position: absolute;
		left: calc((100% - 35px) / 2);
		top: calc((100% - 32px) / 2);
	}

	.i_upload-video {
		width: 100%;
		height: 100%;
	}

	.uploader-div {
		width: 90px;
		height: 90px;
		background: #F2F6FC;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
	}

	.uploader-div .el-icon-plus {
		color: #429FFF;
		font-size: 35px;
		font-weight: bold;
	}

	.gp-product_del {
		position: absolute;
		right: -7px;
		top: -7px;
		color: #999999;
	}

	.form_parameter .el-form-item__label::before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}

	.bt {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}
	
	#yf .el-form-item__label::before,
	#service .el-form-item__label::before,
	#owncode .el-form-item__label::before,
	#classify .el-form-item__label::before{
		content: '';
	}

	.service_item {
		display: inline-block;
		margin-right: 15px;
		padding: 12px 15px;
		font-size: 14px;
		color: #333333;
		line-height: 14px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		cursor: pointer;
	}

	.service_action {
		color: #1989FA;
		border: 1px solid #0486FE;
	}

	.el-input-group__append,
	.el-input-group__prepend {
		padding: 0 5px;
	}

	.ql-clipboard {
		position: fixed;
		display: none;
		left: 50%;
		top: 50%;
	}

	.el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}

	.uoloadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	.disUoloadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.ql-editor {
		height: 600px;
	}

	.el-upload-list--picture-card .el-progress {
		left: 77%;
	}

	.el-progress--circle .el-progress__text,
	.el-progress--dashboard .el-progress__text {
		left: -20px;
	}

	.el-form-item__content .goods_name .el-input__count {
		height: 12px;
		display: block;
		line-height: 12px;
		bottom: 2px;
		right: -35px;
	}

	.el-dialog {
		border-radius: 8px;
	}

	.view_tips {
		margin-bottom: 10px;
		font-size: 16px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}
	
	.pro-cate-view{
		display: flex;
		align-items: center;
		width: 330px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}
	.pro-cate-noallow{
		cursor: not-allowed;
	}
	.pro-cate-place{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #AAAAAA;
		line-height: 14px;
		margin-left: 10px;
	}
	.pro-cate-val{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 14px;
		margin-left: 10px;
	}
	.pro-cate-right{
		margin-left: auto;
		margin-right: 10px;
	}
	
	.no-cate-img{
		width: 126px;
		height: 140px;
		display: block;
		margin: 50px auto 10px;
	}
	.no-cate-txt{
		height: 17px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
		text-align: center;
		margin-bottom: 40px;
	}
	.go-apply-cate{
		width: 96px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		text-align: center;
		display: block;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		margin: 0 auto 40px;
	}
	
	.cate-chose-div{
		display: flex;
		align-items: center;
	}
	.cate-apply-list{
		width: 251px;
		height: 426px;
		background: #F2F6FC;
		border-radius: 4px;
		overflow-y: auto;
	}
	.cate-apply-item{
		width: 215px;
		height: 32px;
		border-radius: 2px;
		border: 1px solid #F2F6FC;
		padding-left: 5px;
		margin: 10px 0 0 5px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.cate-apply-item-name{
		line-height: 32px;
	}
	.cate-apply-item-icon{
		margin: 0 5px 0 auto;
		width: 16px;
		height: 16px;
		display: block;
	}
	.cate-apply-item-act{
		color: #1989FA;
		border: 1px solid #0486FE;
	}
	.cate-chose-bot{
		display: flex;
		align-items: center;
		height: 72px;
	}
	.chose-cate-btn{
		margin-left: auto;
		width: 96px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
	}
	
	
	.add-postage-btn{
		font-size: 12px;
		color: #0486FE;
		margin-left: 18px;
		cursor: pointer;
	}
	
	/* .frei .el-input-group__prepend{
		background: #FFFFFF;
		border-right: 1px solid transparent;
	}
	.frei  .el-input__inner{
		border-left: 1px solid transparent;
	} */
</style>
